document.addEventListener("DOMContentLoaded", function () {
    const AT_PRODUCT_TYPE = 'at';
    const UNDER_PRODUCT_TYPE = 'under';
    const { price, productUnderPrice, productAtPrice } = window.shipping_insurance;
    const typeEvent = window.free_product_config ? "cart-custom:change" : "cart:change";


    getCartJson()
        .then(response => response.items)
        .then(items => updateInsuranceProduct(items))
        .catch(error => console.log(error));

    ["custom-bundle:add",typeEvent].forEach( eventName => {
        document.addEventListener(eventName, (event) => {
            const { items } = event.detail.cart;

            updateInsuranceProduct(items)
                .then(() => {
                    if (typeEvent === "cart-custom:change") {
                        document.dispatchEvent(new CustomEvent("cart:refresh"))
                    }
                });
        });
    })

    function updateInsuranceProduct(items) {
        const { isDisabled, deleteDisabled } = shippingInsurance();
        const disabledShippingInsurance = isDisabled();
        if (disabledShippingInsurance) return delay(0)


        const produtListId = {
            [AT_PRODUCT_TYPE]: productAtPrice,
            [UNDER_PRODUCT_TYPE]: productUnderPrice
        }

        const mainCartLines = getMainCartLine(items);
        const totalCart = getTotalCart(mainCartLines);

        const typeInsurance = Number(price) <= Number(totalCart) ? AT_PRODUCT_TYPE : UNDER_PRODUCT_TYPE;

        const currentProductId = produtListId[typeInsurance];

        const updateForm = getUpdateForm(typeInsurance, productAtPrice, productUnderPrice);
        const updateEmptyForm = getEmptyForm(productAtPrice, productUnderPrice);

        const hasInsuranceProductInCart = isInsuranceProductInCart(items, currentProductId);

        const shouldClearCart = shouldDeleteCart(items, currentProductId);

        if (shouldClearCart) {
            return updateProduct(updateEmptyForm)
                .then(() => {
                    if (typeEvent != "cart-custom:change") {
                        document.dispatchEvent(new CustomEvent("cart:refresh"));
                    }
                })
                .catch((error) => console.log(error))
                .finally(deleteDisabled)
        }
        if (!hasInsuranceProductInCart && !shouldClearCart) {
            return updateProduct(updateForm)
                .then(() => {
                    if (typeEvent != "cart-custom:change") {
                        document.dispatchEvent(new CustomEvent("cart:refresh"));
                    }
                })
                .catch((error) => console.log(error))
        }

        return delay(0)
    }

    function shouldDeleteCart(items, id) {
        return [...items].every(item => item.id == id)
    }

    function getUpdateForm(typeInsurance, productAtPrice, productUnderPrice) {
        const updateForm = {};
        switch (typeInsurance) {
            case AT_PRODUCT_TYPE:
                updateForm[productAtPrice] = 1;
                updateForm[productUnderPrice] = 0;
                break;
            case UNDER_PRODUCT_TYPE:
                updateForm[productAtPrice] = 0;
                updateForm[productUnderPrice] = 1;
                break;
            default:
                break;
        }
        return updateForm;
    }

    function getEmptyForm(productAtPrice, productUnderPrice) {
        const updateForm = {};
        updateForm[productAtPrice] = 0;
        updateForm[productUnderPrice] = 0;
        return updateForm
    }

    function isInsuranceProductInCart(items, productId) {
        return !!items.find(item => item.id == productId);
    }

    function getMainCartLine(items) {
        const array = [];
        for (let index = 0; index < items.length; index++) {
            const element = items[index];
            if (element.id != productUnderPrice && element.id != productAtPrice) {
                array.push(element)
            }
        }
        return array;
    }

    function getTotalCart(items) {
        return [...items].reduce((accumulator, currentItem) => {
            return accumulator + (currentItem.price * currentItem.quantity)
        }, 0)
    }

    function updateProduct(updates) {
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
        })
            .then(response => {
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    function shippingInsurance() {
        const SHIPPING_INSURANCE_KEY = 'disabled-shipping-insurance';

        return {
            setDisabled: () => sessionStorage.setItem(SHIPPING_INSURANCE_KEY, 'true'),
            isDisabled: () => sessionStorage.getItem(SHIPPING_INSURANCE_KEY) === 'true',
            deleteDisabled: () => sessionStorage.removeItem(SHIPPING_INSURANCE_KEY),
        };
    }

    function getCartJson() {
        return fetch("/cart.js").then(response => response.json());
    };

    function delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    document.addEventListener("shipping:insurance", () => {
        shippingInsurance().setDisabled()
    });
});
